import STATUS from '../constants/StatusConstants';
import ColorConstants from '../constants/ColorConstants';

const colorList = [
    ColorConstants.sundown,
    ColorConstants['iris-blue'],
    ColorConstants.padua,
];

const getColorByRangeAndByListOfColors = (value, range, listOfColors) => {
    let color;

    if (value < range[0]) {
        return listOfColors[0];
    }
    if (value >= range[0] && value < range[1]) {
        return listOfColors[1];
    }

    if (value >= range[1]) {
        return listOfColors[2];
    }
    return color;
};

const getColorByRange = (
    value, range = [50, 75],
) => getColorByRangeAndByListOfColors(
    value, range, colorList,
);


export const getColorByRangeInverted = (
    value, range = [90, 110],
) => getColorByRangeAndByListOfColors(
    value, range, colorList.reverse(),
);

// eslint-disable-next-line complexity
export const getColorByStatus = (status = '', defaultColor = ColorConstants.silver) => {
    switch (status.toUpperCase()) {
    case STATUS.CURRENT.toUpperCase():
    case STATUS.ACTIVE.toUpperCase():
        return ColorConstants.padua;

    case STATUS.ENABLED:
        return ColorConstants.shamrock;

    case STATUS.PAUSE:
    case STATUS.PAUSED:
    case STATUS.DISABLED:
    case STATUS.REMOVED:
    case STATUS.INACTIVE.toUpperCase():
        return ColorConstants.salmon;

    case STATUS.ARCHIVED:
        return ColorConstants.manatee;


    case STATUS.PREVIOUS.toUpperCase():
        return ColorConstants['pattens-blue'];

    case STATUS.PLANNED.toUpperCase():
        return ColorConstants.portage;

    default:
        return defaultColor;
    }
};

export const createColorFromName = (name = '', saturation = 30, lightness = 60) => {
    if (name.length === 0) return '';

    const nameHash = name
        .split('')
        .reduce((hash, letter, i) => name.charCodeAt(i) + ((hash < 5) - hash), 0);

    return `hsl(${nameHash % 360}, ${saturation}%, ${lightness}%)`;
};

export default getColorByRange;
